import { SummaryFiltersValidation, useListRiskSummaryFull } from '@/lib/api/risk/summary';
import { CropSettings } from "./CropSettings";

export function RiskRevenueSection({ baseTopLevelResult }: { baseTopLevelResult: ReturnType<typeof useListRiskSummaryFull> }) {
    return <CropSettings className="mt-4" baseTopLevelResult={baseTopLevelResult}/>;
}
